import {getField, updateField} from 'vuex-map-fields';
import History from '@/commonFunction/baseTableModule'

let history_restore = new History('/ws/base_history_restore/');

const state = {
    ...history_restore.state,
    columns: [
        // {text: '', value: 'actions', sortable: false, divider: true, width: 80, brief: true,},
        // {text: 'history_date', value: 'history_date', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_user__username', value: 'history_user__username', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_id', value: 'history_id', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_type', value: 'history_type', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_change_reason', value: 'history_change_reason', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Field', value: 'variable', sortable: true, divider: true, brief: true,},
        // {text: 'old variable', value: 'old_variable', sortable: false, divider: true, width: 80, brief: true,},
        {text: 'In this version', value: 'old_value', true: false, divider: true, brief: true,},
        {text: 'In current version', value: 'value', sortable: true, divider: true, brief: true,},
        // {text: 'changed', value: 'changed', sortable: true, divider: true, width: 80, brief: true,},
    ],
    options: {
                page: 1,
                itemsPerPage: 10000,
                sortBy: ['variable'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: true,
            },
};
const getters = {
    ...history_restore.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...history_restore.actions,
};
const mutations = {
    ...history_restore.mutations,
};

export default {
    modules: {
        BaseHistoryRestore: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}